import React from "react";

import ContentCore from "../../../core/workingContent";

import "../_index.css";

const TaskEndToday = () => {
  return (
    <>
      <ContentCore />
    </>
  )
}

export default TaskEndToday;
